<template>
  <div class="modal show fade modal-danger text-left" style="display: block;" v-if="show">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title" style="text-transform:capitalize;">Details</h4>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="$emit('hide')">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="card">
            <div v-if="list.length" class="card-body table-responsive p-0 table-striped table-hover table-bordered" >
              <table class="table table-head-fixed table-hover-animation text-nowrap">
                <thead>
                <tr>
                  <th>Status</th>
                  <th>Comments</th>
                  <th>Time/Date</th>
                </tr>
                </thead>
                <tbody>
                <tr :key="index" v-for="(row, index) in list" >
                  <td>{{row.status_str}}</td>
                  <td>{{row.comment}}</td>
                  <td>{{customFormatDateTime(row.created_at)}}</td>
                </tr>
                </tbody>
              </table>
            </div>
            <div class="card-body text-center text-primary" v-else>
              No Details Avaliable
            </div>
          </div>
        </div>
        <div class="modal-footer justify-content-between">
          <button type="button" class="btn btn-danger" data-dismiss="modal" @click="$emit('hide')">Close</button>
        </div>
      </div>
    </div>
  </div>
  <div v-if="show" class="modal-backdrop fade show"></div>
</template>

<script>

export default {
  props: ['show', 'data', 'index'],
  data() {
    return {
      list: [],
      // showModal: false,
    }
  },
  mounted() {
    // this.list = this.data
  },
  methods: {
    setupData() {
    }
  },
  watch: {
    show() {
      this.list = this.data
    },
    detailType() {

    }
  }
}
</script>

<style scoped>
.modal-dialog {
  overflow-y: initial !important
}

.modal-body {
  height: 70vh;
  overflow-y: auto;
}
</style>

